__turbopack_context__.v({
  "className": "dm_sans_a1b81819-module__772HwW__className",
  "variable": "dm_sans_a1b81819-module__772HwW__variable",
});
